<template>
  <base-dialog class="option-set-list-dialog" show-close :visible.sync="visible" @closed="submit">
    <template v-slot:header>使用选项集</template>
    <div style="margin-bottom: 8px;margin-top: 10px;">
      选项集可以使一组选项在其他工作表中共用。你可以新建选项集或将一个已有的自定义选项转为选项集后再使用。
    </div>
    <div style="display:flex">
      <span class="tab">选项集</span>
      <div class="select-ref">
        <div class="left">
          <el-select v-model="optionSetId" placeholder="">
            <el-option
              v-for="item in optionSetList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
              {{ item.name }}
            </el-option>
          </el-select>
        </div>
        <div class="right" @click="$refs.optionSetDialog.open()">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="visible = false" :disabled="!selectedOptionSet">
        确 定
      </el-button>
    </span>
    <option-set-dialog
      ref="optionSetDialog"
      :optionSetId="optionSetId"
      :appId="appId"
      @submit="closeOuterDialog"
      append-to-body
    ></option-set-dialog>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import { getOptionSetList } from "@/api/sheet/sheetOptionSet"
import OptionSetDialog from "./optionSet-dialog.vue"

export default {
  name: "option-set-list-dialog",
  components: {
    OptionSetDialog,
    BaseDialog
  },
  props: {
    appId: String
  },
  computed: {
    selectedOptionSet() {
      return this.optionSetList.find(optionSet => optionSet.id === this.optionSetId)
    }
  },
  data() {
    return {
      visible: false,
      optionSetList: [],
      optionSetId: ""
    }
  },
  methods: {
    open() {
      this.visible = true
      this.optionSetId = ""
      getOptionSetList().then(optionSetList => {
        this.optionSetList = optionSetList
      })
    },
    submit() {
      this.$emit("submit", this.selectedOptionSet)
    },
    closeOuterDialog(data) {
      this.open()
    }
  }
}
</script>

<style lang="scss" scoped>
.option-set-list-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px 15px;
  }
  .el-select {
    width: 100%;
  }
  .tab {
    font-size: 14px;
    width: 72px;
    margin: auto;
    color: #3d3140;
  }
  .select-ref {
    display: flex;
    .left {
      width: 408px;
      .el-select {
        ::v-deep .el-input__inner {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
    }
    .right {
      @include flex-center;
      min-width: 32px;
      height: 32px;
      background: $color-bg-select;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #d8dce6;
      border-left-width: 0;
      cursor: pointer;
      box-sizing: border-box;
      &:hover:not(.is-disabled) {
        color: $color-main;
      }
    }
  }
}
</style>
